import { FormsyInput } from '@thanx/uikit/input'
import { FormsyRadioGroup, Radio } from '@thanx/uikit/radio'
import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import LinkTargetPicker from 'scenes/Cms/components/LinkTargetPicker'
import UrlPicker from 'scenes/Cms/components/UrlPicker'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import { mergeTags } from './helpers'
import Preview from './Preview'
import TextInput from './TextInput'

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.content.personalized_text'
)

type Props = {
  blockId: string
  contentBlock: ContentBlockData
}

const PersonalizedTextContent = ({ blockId, contentBlock }: Props) => {
  const { type, settings } = contentBlock
  if (type !== 'personalized_text') return <></>

  const { url } = contentBlock
  const { text, placeholder_values, fallback_behavior, link_target } = settings

  return (
    <>
      <TextInput name={`${blockId}.settings.text`} text={text ?? ''} />

      <Text.Header4 color="grey70" tag="p" className="mt-m">
        {t('preview')}
      </Text.Header4>
      <Preview contentBlock={contentBlock} />

      <Text.Header4 color="grey70" tag="p" className="mt-m">
        {t('fallback_behavior.title')}
      </Text.Header4>
      <FormsyRadioGroup
        name={`${blockId}.settings.fallback_behavior`}
        label={t('fallback_behavior.description')}
        align="vertical"
        value={fallback_behavior}
      >
        <Radio className="mr-s" value={'hide'}>
          {t('fallback_behavior.hide')}
        </Radio>
        <Radio value={'show_placeholders'}>
          {t('fallback_behavior.show_placeholders')}
        </Radio>
      </FormsyRadioGroup>

      <Switch condition={fallback_behavior === 'show_placeholders'}>
        <table>
          <tbody>
            {mergeTags
              .filter(
                tag =>
                  tag.supportsPlaceholder &&
                  (text ?? '').includes(`{{${tag.key}}}`)
              )
              .map(tag => (
                <tr key={tag.key}>
                  <td className="p-s">
                    <Text.BodyText3 color="grey90">{tag.label}</Text.BodyText3>
                  </td>
                  <td className="p-s">
                    <FormsyInput
                      name={`${blockId}.settings.placeholder_values.${tag.key}`}
                      value={placeholder_values?.[tag.key] || ''}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Switch>

      <Text.Header4 color="grey70" tag="p" className="mt-m">
        {t('linking')}
      </Text.Header4>
      <UrlPicker
        id={blockId}
        type="text"
        url={url}
        required={false}
        hasQueryParam
      >
        <LinkTargetPicker id={blockId} url={url} linkTarget={link_target} />
      </UrlPicker>
    </>
  )
}

export default PersonalizedTextContent
